import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Input } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { TemplateSubTaskType } from './type';

type TatTimeInputProps = {
  subtaskId: string;
  getchangedTat: (oldTat: string, changedTat: string) => void;
};

function TatTimeInput({ subtaskId, getchangedTat }: TatTimeInputProps) {
  const { TemplateStore } = useStore();
  const [tatTime, setTatTime] = useState<string>('');

  const tatChange = (e: any) => {
    getchangedTat(tatTime, e.target.value);
    setTatTime(e.target.value);
  };
  useEffect(() => {
    const subTask = TemplateStore.selectedTasks
      ?.subTasks as TemplateSubTaskType[];
    subTask.forEach((subTask: TemplateSubTaskType) => {
      if (subTask.subTaskId === subtaskId) {
        setTatTime(subTask.tATTime);
      }
    });

    //eslint-disable-next-line
  }, [TemplateStore.selectedTasks]);
  return (
    <>
      <Header as="h5" style={{ marginBottom: '3px' }}>
        Turn Around Time - Number of days to complete sub task
      </Header>
      <Input
        value={tatTime}
        name="tatTime"
        onChange={(e) => tatChange(e)}
        style={{
          width: '100%',
          borderColor: 'hsl(0, 0%, 80%)',
          height: '33px',
          borderRadius: '5px',
        }}
      />
    </>
  );
}

export default observer(TatTimeInput);
